import { Record } from "immutable"

import {
    toUI as defaultToUI,
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    idify,
} from "../model-utils"
import { toUI as conceptToUI } from "./concept"
import moment from "moment"

export const FeedModel = new Record({
    id: "",
    approved: null,
    approval_suggestion: null,
    attachment: null,
    authors: [],
    concepts: [],
    creator: null,
    dimensions: [],
    embedded_media: null,
    fp: [],
    fp_topics: [],
    image: "",
    imagePreviewURL: undefined,
    language: "",
    license: "",
    link: "",
    publisher: "",
    publisher_details: null,
    rejection_reason: null,
    source: null,
    static_topics: [],
    summary: "",
    time: moment(),
    time_analyzed: moment(),
    title: "",
    topics: [],
})

const dateFields = ["time", "time_analyzed"]
const tagFields = []
export const normalisingFields = ["authors", "concepts", "dimensions", "topics"]
const addRemoveFields = ["topics"]

export const normalise = (feed) => normaliseModel(feed, ...normalisingFields)
export const hydrate = (feed, ...entityStates) =>
    hydrateModel(feed, normalisingFields, entityStates)

export const authorToUI = (author) => {
    if (typeof author === "string" || author instanceof String) {
        return {
            id: author,
            label: author,
        }
    } else {
        return author
    }
}

const topicToUI = ({ score, ...topic }) => ({
    ...topic,
    score: score ? score.toPrecision(3) : null,
})

const fpConceptToUI = ({ normalized_count, ...fpConcept }) => ({
    ...fpConcept,
    score: normalized_count.toFixed(3),
})

export const updateFeedChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) => {
    if (name === "authors") {
        return changeModel.set("authors", idify(value))
    } else {
        return updateChangeModel(
            name,
            value,
            changeModel,
            workingModel,
            addRemoveFields,
            dateFields
        )
    }
}

export function toUI(feed) {
    if (!feed) {
        return feed
    }

    feed = defaultToUI(feed, dateFields, tagFields)
        .set("concepts", (feed.get("concepts") || []).map(conceptToUI))
        .set("authors", (feed.get("authors") || []).map(authorToUI))
        .set("fp", (feed.get("fp") || []).map(fpConceptToUI))
        .set("topics", (feed.get("topics") || []).map(topicToUI))
        .set("fp_topics", (feed.get("fp_topics") || []).map(topicToUI))
        .set("static_topics", (feed.get("static_topics") || []).map(topicToUI))
    return feed
}
